import React, { Component } from 'react';

class Rules extends Component {
  render() {
    return (
      <div>
        <h1 className="title">Superkick 2026 Rules</h1>

        <p>Welcome to Superkick 2026.</p>

        <p>
          In 2026 Superkick will again feature two leagues of 10 teams, but for the
          first time both competitions will be fully integrated into a single
          19-round home-and-away season where every team plays every other team once.
        </p>

        <p>The two competitions will remain separate:</p>

        <ol>
          <li>Superkick Bendigo</li>
          <li>Superkick Melbourne</li>
        </ol>

        <p>
          Each league will maintain its own ladder with the top five teams qualifying
          for finals.
        </p>

        <h2>1. THE GAME</h2>

        <p>
          Each Superkick team selects 25 AFL goal scorers. Each week your top 8
          scorers will count toward your match score in head-to-head games.
        </p>

        <p>Scores are calculated using goals and behinds (eg 6.1 = 37 points).</p>

        <h3>Example Match</h3>

        <p>Flying Saucers</p>

        <p>Counted Scores</p>

        <ol>
          <li>Franklin 6.1</li>
          <li>Wingard 4.2</li>
          <li>Giansiracusa 2.0</li>
          <li>Henderson 1.2</li>
          <li>McIntosh 1.1</li>
          <li>Lynch 1.1</li>
          <li>Sandilands 1.1</li>
          <li>Daniher 1.0</li>
        </ol>

        <p>Non Counted Scores</p>

        <ol>
          <li>Black 1.0</li>
          <li>Hill 0.3</li>
          <li>Edwards 0.1</li>
        </ol>

        <p>Score: 17.8 (110)</p>

        <p>Lost to</p>

        <p>East Quiche</p>

        <p>Counted Scores</p>

        <ol>
          <li>Pavlich 5.3</li>
          <li>Day 4.0</li>
          <li>Crameri 3.3</li>
          <li>Betts 2.2</li>
          <li>Cooney 1.1</li>
          <li>Ballantyne 1.0</li>
          <li>Carlisle 1.0</li>
          <li>Varcoe 0.3</li>
        </ol>

        <p>Non Counted Scores</p>

        <ol>
          <li>Brown 0.1</li>
        </ol>

        <p>Score: 17.12 (114)</p>

        <p>
          <i>
            East Quiche wins by 4 points even though the Saucers kicked more overall
            goals because only the top 8 scorers count.
          </i>
        </p>

        <h2>2. THE DRAFT</h2>

        <p>
          Draft order will be determined by the Western Australia vs Victoria State
          of Origin game on February 14.
        </p>

        <p>Each Superkick team submits:</p>

        <ol>
          <li>5 nominated players ranked 1–5</li>
          <li>2 emergency selections</li>
          <li>A match tip and winning margin</li>
        </ol>

        <p>
          The highest combined score from the nominated players will receive Pick 1.
        </p>

        <p>If there is a tie:</p>

        <ol>
          <li>The highest ranked player with a different score decides the pick.</li>
          <li>If still tied the match tip and margin will decide.</li>
        </ol>

        <p>Example:</p>

        <p>Flying Fortress and Bamboozled Asians both score 8.5 (53)</p>

        <ul>
          <li>Fortress top pick: Cameron 2.4</li>
          <li>Asians top pick: Curnow 2.1</li>
        </ul>

        <p>Fortress receives the higher draft pick.</p>

        <p>The draft will run in a snake order.</p>

        <h2>3. PLAYER TRADING RULES / ADD ONS</h2>

        <ol>
          <li>
            Teams may draft up to 25 players. From Pick 16 onwards teams may pass and
            save add-ons.
          </li>

          <li>
            Passing at Pick 16 leaves 9 add-ons for the season. Passing at Pick 19
            leaves 6 add-ons. Drafting all 25 players leaves zero add-ons.
          </li>

          <li>
            Players may only be traded from the unselected player pool prior to the
            GWS vs Hawthorn game on Saturday March 7 at 4:15pm.
          </li>

          <li>
            After this time all squads are locked and only add-ons are allowed.
          </li>

          <li>
            Add-ons can occur anytime after the draft. The cut-off for that week is
            the first Saturday match of the round. Any add-on after that will apply
            to the following round.
          </li>
        </ol>

        <h3>Long Term Injury Rule (Top 2 Picks)</h3>

        <p>
          If one of your top two picks misses 8 games (not necessarily consecutive)
          you may replace them with any unselected player.
        </p>

        <ul>
          <li>You may trade them out before they reach 8 missed games.</li>
          <li>They cannot return to your team until 8 games have been missed.</li>
          <li>
            If they return earlier their scores will not count until the 8 game
            threshold is reached.
          </li>
        </ul>

        <h2>4. SEASON STRUCTURE</h2>

        <h3>Home and Away</h3>

        <p>
          There will be 19 home-and-away rounds where every team plays each other
          once.
        </p>

        <ul>
          <li>Bye rounds will be played through.</li>
          <li>Short-handed weeks due to byes are considered bad luck.</li>
        </ul>

        <h3>League Matchups</h3>

        <ul>
          <li>Full rounds within your league</li>
          <li>Cross league games during bye rounds</li>
          <li>Gather Round (Round 5) and Round 18 are also cross league rounds</li>
        </ul>

        <h3>Finals Structure</h3>

        <p>Top 5 teams from each league qualify for finals.</p>

        <h4>Week 1</h4>

        <ul>
          <li>Qualifying Final 2 vs 3</li>
          <li>Elimination Final 4 vs 5</li>
        </ul>

        <h4>Week 2</h4>

        <ul>
          <li>1st Semi Final – QF loser vs EF winner</li>
          <li>2nd Semi Final – 1st vs QF winner</li>
        </ul>

        <h4>Week 3</h4>

        <p>Preliminary Final – Loser 2nd Semi vs Winner 1st Semi</p>

        <h4>Week 4</h4>

        <p>League Grand Final</p>

        <h4>Week 5</h4>

        <p>
          Superkick Grand Final – Bendigo League Champion vs Melbourne League
          Champion
        </p>

        <h3>Drawn Finals</h3>

        <p>If a final is drawn it will be decided by:</p>

        <ol>
          <li>9th scorer</li>
          <li>10th scorer and so on</li>
          <li>Highest individual scorer</li>
          <li>Next highest scorer</li>
          <li>Higher ladder position</li>
        </ol>

        <h2>5. Brent Hodge Cup</h2>

        <p>
          The Brent Hodge Cup returns in 2026 in honour of our late mate Brent
          Hodge who inspired Superkick back in 2000 and coached the Flying Saucers
          to the 2001 premiership.
        </p>

        <p>Inaugural Winner: Bamboozled Asians</p>
        <p>Reigning Champions: Goalfest</p>

        <h3>Format</h3>

        <ul>
          <li>Opening Round acts as a seeding round</li>
          <li>All players count toward the qualifying score</li>
          <li>Teams ranked 1–12 qualify automatically</li>
          <li>Teams ranked 13–20 play Round 11 knockouts</li>
          <li>Final 16 knockout format</li>
        </ul>

        <h3>BH Cup Schedule</h3>

        <ul>
          <li>Round 18 – Round of 16</li>
          <li>Round 20 – Quarter Finals</li>
          <li>Round 22 – Semi Finals</li>
          <li>Round 24 – Final</li>
        </ul>

        <h2>PRIZES</h2>

        <h3>Entry Fee: $120 per team</h3>

        <ol>
          <li>Overall Champion – $800</li>
          <li>Overall Runner Up – $550</li>
          <li>League Runners Up (x2) – $250</li>
          <li>League Preliminary Finalists (x2) – $125</li>
          <li>Highest Season Score – $100</li>
          <li>BH Cup Winner – $200</li>
        </ol>

        <p><b>Have fun at the draft and enjoy the season.</b></p>

        <p>Your League Administrator</p>
        <p>Ricky Walsh</p>
        <p>East Quiche Coach</p>
        <p>2014, 2015 & 2024 Premiers</p>
      </div>
    )
  }
}

export default Rules;